
export const state = () => ({
  total: 0,
  perPage: 25,
  organizations: [],
  page: {
    current: 1,
  },
  filter: {
    search: '',
  },
  generation: 0,
});

export const mutations = {
  ORGANIZATIONS_SET(state, payload) {
    state.organizations = payload;
  },
  ORGANIZATIONS_TOTAL_SET(state, payload) {
    state.total = payload;
  },
  PAGE_UPDATE(state, payload) {
    state.page = { ...state.page, ...payload };
  },
  GENERATION_SET(state, payload) {
    state.generation = payload;
  },
  FILTER_UPDATE(state, payload) {
    state.filter = { ...state.filter, ...payload };
  },
};

export const getters = {
};

export const actions = {
  async getOrganizations({ commit, state }) {
    const response = await currentReply({ commit, state }, () => useApi.get('/operator/users', {
      params: {
        limit: state.perPage,
        page: state.page.current,
        staff: 0,
        type: 2,
        q: state.filter.search.length > 2 ? state.filter.search : undefined,
      },
    }));

    // Null means a newer load has overtaken this one; the caller keeps its mask up.
    if (response === null) return false;

    commit('ORGANIZATIONS_SET', response.results);
    commit('ORGANIZATIONS_TOTAL_SET', response.count);

    return true;
  },

  changePage({ commit, dispatch }, to) {
    commit('PAGE_UPDATE', { current: to });
    return dispatch('getOrganizations');
  },
};
